import helperDataTable from "../../../components/helpers/helperDataTable";

export const getEntities = (context, apiEntities, fullAccountApplicationId, hideSpinner, setEntities, setApiActionErr, setApiErr, error502, setError502) => {
    
    apiEntities.getAll(fullAccountApplicationId)
        .then(function (response) {

            const entities = response;
            hideSpinner();
            setEntities(entities);
            setApiActionErr(null);
            setApiErr(null);
        
            if (response.length > 0){
                setTimeout(helperDataTable("#entitiesListTable", 10, context), 200);
            }

        // }).catch(function (error) {
        }).catch((error) => {
            console.log("Loggin of Catch error in _getEntities: " + error);
            console.log("error.response: " + error.response);
            const errorCode = error.response.status;
            
            if (errorCode !== 502){
                hideSpinner();
                setApiErr(error);
                return;
            } 
            console.log("Catch error in _getEntities. Process should be retraing execution due 502 error: " + errorCode);
            // Set "error502" in a new value in order to try once again useEffect execution
            setError502(error502 + 1);
        });
}